import { API } from "apis";
import { getViaAuth, responseValidator } from "apis/api";
import { PaginationList } from "core/domain";
import { OldTxId } from "core/domain/old-tx-ids/old-tx-ids";

export const getAllOldTxIds = async (
    setLoading: any,
    setData: any,
    page: number,
    itemsPerPageCount: number,
    query?: string,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<OldTxId>>(
        API.oldTxIds.all + '/' + page + '/' + itemsPerPageCount + `${query || ''}`,
    ).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            if (response.value) {
                setData(response.value);
            }
        }
    });
};